import React from 'react';
import Card from '../../common/Card';
import { Skeleton } from '../../common/Skeleton';
import './key-metrics-card-skeleton.scss';

/**
 * Skeleton loader for Key Metrics cards.
 */
const KeyMetricsCardSkeleton: React.FC = () => (
  <Card width={360} height="auto">
    <div className="key-metrics-card-skeleton">
      <div className="key-metrics-card-skeleton__header">
        <Skeleton width={60} height={14} className="skeleton--delay-1" />
        <Skeleton width={55} height={20} className="key-metrics-card-skeleton__badge skeleton--delay-2" />
      </div>
      <div className="key-metrics-card-skeleton__values">
        <div className="key-metrics-card-skeleton__value-group">
          <Skeleton width={120} height={28} className="skeleton--delay-3" />
          <Skeleton width={40} height={12} className="skeleton--delay-4" />
        </div>
        <div className="key-metrics-card-skeleton__value-group">
          <Skeleton width={70} height={18} className="skeleton--delay-5" />
          <Skeleton width={40} height={12} className="skeleton--delay-6" />
        </div>
      </div>
      <Skeleton width="100%" height={1} className="key-metrics-card-skeleton__divider skeleton--delay-7" />
      <Skeleton width={180} height={12} className="skeleton--delay-8" />
    </div>
  </Card>
);

export default KeyMetricsCardSkeleton;
